import { useState } from "react";
import { handleOpenFile } from "@packages/shared/utils";
import { useV2TableInternal } from "../context/V2TableInternalContext";

const useFileDownloadV2 = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | null>(null);
  const { axiosInstance } = useV2TableInternal();

  const downloadFile = async (
    url: string,
    includeParams: boolean,
    id: string,
    body: any
  ) => {
    if (!url || !id) return;

    setIsLoading(true);
    setError(null);

    try {
      if (!axiosInstance) {
        throw new Error(
          "Axios instance not found. Please ensure you have provided an axios instance via DynamicTableV2 props."
        );
      }

      const response = await axiosInstance.post(
        `${url}/${includeParams ? id : ""}`,
        { ...body }
      );

      const { name, content } = response.data;
      handleOpenFile(name, content);
    } catch (err) {
      console.error("Error fetching the file:", err);
      setError(err as Error);
    } finally {
      setIsLoading(false);
    }
  };

  return { isLoading, error, downloadFile };
};

export default useFileDownloadV2;
